import { gql } from '@apollo/client';

const typeDefs = gql`
  directive @client on FIELD
  
  extend type Media {
    image(size: Int = 1000): Image
  }

  extend type Fulfillment {
    isBODFS: Boolean
    bodfs: Service
    isBOPIS: Boolean
    bopis: Service
    isBOSS: Boolean
    boss: Service
    storeType: String
    isCurrentlyUnavailable: Boolean
    isOutOfStockOnline: Boolean
    isSTH: Boolean
    shipToHome: Service
    isFulfillable: Boolean
    method: String
  }

  extend type Identifiers {
    isAppliance: Boolean
  }

  extend type AvailabilityType {
    isFulfillableIRGSku: Boolean
  }

  extend type BaseProduct {
    isBrowseOnly: Boolean
    fulfillmentMethod: String
  }

  extend type FbrProduct {
    isBrowseOnly: Boolean
    fulfillmentMethod: String
  }

  extend type CollectionProduct {
    isBrowseOnly: Boolean
    fulfillmentMethod: String
  }

  extend type DynamicRecsProduct {
    isBrowseOnly: Boolean
    fulfillmentMethod: String
  }

  extend type EndCapProduct {
    isBrowseOnly: Boolean
    fulfillmentMethod: String
  }
`;

export default typeDefs;
